export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: 'full',
      action: 'show',
      resource: 'Auth',
    },
  },
  {
    path: '/pages/not-authorized',
    name: 'not-authorized',
    component: () => import('@/views/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      action: 'show',
      resource: 'Auth',
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      action: 'show',
      resource: 'Auth',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]
